#### New error on `closePostedPositionProfile`

On the 31st of March 2025, the [`closePostedPositionProfile`] mutation will return an error if your software attempts to close a job ad that has already been closed.

Errors will be returned with the following structure:

```json
{
  "errors": [
    {
      "message": "Job ad is already closed",
      "locations": [{ "line": 2, "column": 3 }],
      "path": ["closePostedPositionProfile"],
      "extensions": {
        "code": "FORBIDDEN"
      }
    }
  ],
  "data": {
    "closePostedPositionProfile": null
  }
}
```

This change is intended to increase partner awareness of potential synchronisation issues between their software and SEEK.

Your software can subscribe to receive a [`PositionProfileClosed` event] whenever a job ad has been closed.
It’s recommended that you update your software’s internal state based on [`PositionProfileClosed` event].
Review the [Managing job ads] guide for further information on a job ad’s lifecycle.

[`closePostedPositionProfile`]: /schema/mutation/closePostedPositionProfile
[`PositionProfileClosed` event]: /use-cases/job-posting/managing-job-ads/closing-a-job-ad#positionprofileclosed
[Managing job ads]: /use-cases/job-posting/key-concepts#job-ad-lifecycle
